import React, { Suspense, useState, useEffect } from "react";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { CommonUtilities } from "../../commonUtils";
import projectServices from "./projectServices"
import ProjectIndicators from "../Common/projectIndicators";
import ContractListing from "../Contracts/ContractListing";
import SongListing from "../MetaData/Songs/SongListing";
import ReleaseListing from "../MetaData/Release/ReleaseListing";
import TrackListing from "../MetaData/Tracks/TrackListing";
import UserListing from "../Users/UserListing";
import Performance from "../container/Performance";
import Royalties from "../container/Royalties";
import ProjectAnalysis from "../container/ProjectAnalysis";
import ProjectValidation from "../container/ProjectValidation";
import AssetLinking from "../AssetLinking/AssetLinking";
import AffiliatePeriod from "../PeriodSelection/AffiliatePeriod";
import NewSongs from "../MetaData/Songs/addSong";
import { format } from "date-fns";
import ContractCompare from "../container/ContractCompare";
import ProjectCalculation from "./projectCalculation";
import TooltipList from "../Common/tooltip";
import { AddUser } from "../Users/addUser";
import CurrentJobs from "../../components/User Profile/CurrentJobs";
import ProjectSlider from "./projectSlider";
import ProjectSummarySetting from "./projectSettings";
import ClientProfileServices from "../../components/User Profile/Client Profiles/clientProfileServices";
import MainWizard from "../wizard/MainWizard";
import cachingMechanisum from "../Common/cachingMechanisum";

export default function ProjectSummary(projectDetails: any) {

    const [showtab, setShowTab] = useState(1);
    var [client, setClient] = useState<any>([]);
    const [Associated, SetAssociated] = useState(0)
    const getRows = (e: any) => { SetAssociated(e) }
    const [sndSearch, setSndSearch] = useState("")
    const searchBtn = (e: any) => { setSndSearch(e); }
    const [searchValue, setSearchValue] = useState("");
    const [showData, setShowData] = useState("Contracts");
    const [selectPeriod, SetSelectedPeriod] = useState("");
    const [openFirst, setOpenFirst] = React.useState(false);
    const [descriptButton, setDescriptButton] = useState(false);
    const [projectSettingUi, setprojectSettingUi] = useState(false);
    const [DescriptionList, initDescriptionList] = useState<any[]>([]);
    var [projectIndicators, initprojectIndicators] = useState<any>([]);

    const currentPage = (e: React.SetStateAction<number>) => {
        setShowTab(e);
        if (e === 1) setShowData("Contract")
        else if (e === 4) setShowData("Release")
        else if (e === 3) setShowData("Songs")
        else if (e === 2) setShowData("Tracks")
        else if (e === 5) setShowData("Users")

        return 1;
    }

    const getClient = () => {

        ClientProfileServices.clientDetails().then((res) => {
            setClient(res[0])
        })

    }
    var periodSummary = {
        classList: null,
        kontactCode: projectDetails?.projectDetails?.kontactCode,
        kontactDisplay: projectDetails?.projectDetails?.kontactDisplay,
        periodFrom: 0,
        projectCode: projectDetails?.projectDetails?.projectCode,
        projectId: projectDetails?.projectDetails?.projectId,
        projectName: projectDetails?.projectDetails?.projectName,
        projectOwner: projectDetails?.projectDetails?.projectOwner,
        projectType: projectDetails?.projectDetails?.projectType,
        status: Number(projectDetails?.projectDetails?.status)
    }

    let [periodSelected, SetperiodSelected] = useState<any>([]);



    const getIndicator = () => {
        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        //console.log(periodListCache)
        for (var i = 0; i < periodListCache.length; i++) {
            if (periodListCache[i]?.periodCurrent === 1) {
                periodSelected = periodListCache[i]
                SetperiodSelected(periodSelected)
            }
        }
        if (selectPeriod === "") { periodSummary.periodFrom = Number(periodSelected?.periodFrom) }
        else (periodSummary.periodFrom = Number(format(new Date(selectPeriod), 'yyyyMMdd')))

        projectServices.projectIndicators(periodSummary).then((res) => {
            initprojectIndicators(res)
        })
    }


    const onChangeDate = (e: any) => {
        SetSelectedPeriod(e)
        getIndicator()
    }

    const onChange = (period: any) => {
        console.log(period)
    }

    const expandDescription = () => {
        setDescriptButton(!descriptButton)
        projectServices.descriptionList({
            "projectId": projectDetails?.projectDetails?.projectId,
            "pageNumber": 1,
            "pageSize": 10
        }).then((res) => {
            initDescriptionList(res)
        })
    }

    const projectSetting = () => {
        setprojectSettingUi(true)
    }

    const MainWizardClose = () => {
        setopenMainWizard(false)
    }

    const AssetLinkClose = () => {
        setopenAssetLink(false)
    }

    let [openMainWizard, setopenMainWizard] = useState(false)
    let [openAssetLink, setopenAssetLink] = useState(false)
    let [openProjectAnalysis, setopenProjectAnalysis] = useState(false)

    const ProjectAnalysisopen = () => {
        openProjectAnalysis = true;
        setopenProjectAnalysis((prev:Boolean )=> !prev);

        console.log(openProjectAnalysis)
    }

    const ProjectAnalysisClose =() =>{        
        setopenProjectAnalysis((prev:Boolean )=> !prev);
    }

    return (
        <div className="pull-left">
            <a className='text-bold' onClick={() => { setOpenFirst(true); getClient(); getIndicator(); }}> {projectDetails?.projectDetails?.projectName} ({projectDetails?.projectDetails?.projectCode})</a>

            <Modal open={openFirst} onClose={() => setOpenFirst(false)} center>

                <div className="box">
                    <div className="box-header-main">
                        <h2 className="ws-3">Project Summary</h2>
                        <div className="ws-1 pull-right "><CurrentJobs type={"calculation"} /> </div>
                    </div>
                    <div className="box-content p0">
                        <div className="ws-3 pm">
                            <div className="ws-12 mb">
                                <span className="text-bold">{projectDetails?.projectDetails?.projectName} </span>
                                ({projectDetails?.projectDetails?.projectCode})

                                <button className="btn btn-xs pull-right" onClick={projectSetting}>
                                    <i className="icon-LPurple-Setting m0 p0"></i>
                                </button>
                            </div>

                            <hr className="ws-11 dottedHr mts"></hr>

                            <div className="ws-12">
                                <span className="pull-left mt mr primary">Project Type : </span>
                                {
                                    CommonUtilities.stringToArray(projectDetails?.projectDetails?.projectType, ',').map((projectTypeName: any) => {
                                        return (
                                            <div className="pull-left mb">
                                                <a className="btn-xs m0 mrs" style={{ background: CommonUtilities.lookUpTypeList('projectTag', projectTypeName, 'bgColor'), color: CommonUtilities.lookUpTypeList('projectTag', projectTypeName, 'fontColor') }}>
                                                    {projectTypeName}
                                                </a>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div className="ws-12 mt mb">

                                <span className="pull-left mt mr primary">Project Status : </span>

                                <a className={projectDetails?.projectDetails?.statusDescription ? 'btn-xs m0 mrs btn-warning' : 'hide'}>
                                    {projectDetails?.projectDetails?.statusDescription}
                                </a>

                                <a className={projectDetails?.projectDetails?.statusDescription ? 'btn-xs m0 mrs hide' : 'hide'}
                                    style={{
                                        background: CommonUtilities.lookUpTypeList('contractStatusName', projectDetails?.projectDetails?.statusDescription, 'bgColor'),
                                        color: CommonUtilities.lookUpTypeList('contractStatusName', projectDetails?.projectDetails?.statusDescription, 'fontColor')
                                    }}>
                                    {projectDetails?.projectDetails?.statusDescription}
                                </a>

                            </div>

                            <hr className="ws-11 mt dottedHr" />

                            <div className="ws-12 mt">
                                <span className="primary">Project Owner : </span>{projectDetails?.projectDetails?.projectOwner}
                            </div>

                            <div className="ws-12 mtl">
                                <span className="primary">Contact : </span>{projectDetails?.projectDetails?.kontactDisplay}
                            </div>

                            <div className="ws-12 mtl">
                                <span className="primary">MPM/Class : </span>{projectDetails?.projectDetails?.classList}
                            </div>

                            <hr className="ws-11 dottedHr mtl" />
                            <div className="ws-12 hide ">
                                <span className="pull-left primary mb mt pt">Reports</span>
                                <button className="btn-xs icon-btn delete" type="button">
                                    <TooltipList text={"contract"}><i className="icon-file-pdf-o"></i></TooltipList>
                                </button>
                            </div>

                            <hr className="ws-11 dottedHr mtl" />

                            <div className="ws-11 leftFrame landing mt pLarge">
                                <span className="ws-12">Total for the project</span>
                                <span className="ws-11 pts">{client && client.homeCurrency ? client.homeCurrency : ''} {projectIndicators.endBalance}</span>
                                <div ><ProjectSlider type="totalProject" /></div>
                            </div>

                            <div className="ws-11 leftFrame landing mt pLarge">
                                <span className="ws-7">Payments</span>
                                <span className="ws-7 pts">{client && client.homeCurrency ? client.homeCurrency : ''} {projectIndicators.lastPayment}</span>
                                <div ><ProjectSlider type="payments" data={projectDetails.projectDetails} /></div>
                            </div>

                            <div className="ws-11 leftFrame landing mt pLarge">
                                <span className="ws-12">Lifetime Royalties</span>
                                <span className="ws-12 pts">{client && client.homeCurrency ? client.homeCurrency : ''} {projectIndicators.lifetimeroyalty}</span>
                                <div ><ProjectSlider type="Earnings" data={projectDetails.projectDetails} /></div>
                            </div>

                            <div className="ws-11 leftFrame landing mt pLarge">
                                <span className="ws-12">Lifetime Royalties - Third Parties</span>
                                <span className="ws-12 pts">{client && client.homeCurrency ? client.homeCurrency : ''} {projectIndicators.lifetimeroyaltyThirdParties}</span>
                                <div ><ProjectSlider type="Earnings" data={projectDetails.projectDetails} /></div>
                            </div>

                            <div className="ws-11 leftFrame landing mt pLarge">
                                <span className="ws-12">Lifetime Recoupables</span>
                                <span className="ws-12 pts">{client && client.homeCurrency ? client.homeCurrency : ''} {projectIndicators.totalCosts}</span>
                                <div ><ProjectSlider type="costs" data={projectDetails.projectDetails} /></div>
                            </div>

                            <div className="ws-11 topFrame box mtl">
                                <div className="box">
                                    <div className="box-header">
                                        <h2 className="ws-8">Description</h2>
                                        <button className="btn-xs icon-btn primary hover-box badge pull-right" onClick={expandDescription}>
                                            <i className={!descriptButton ? 'icon-plus1' : 'icon-minus1'} >
                                            </i>
                                        </button>
                                    </div>

                                    {descriptButton && <div className="box-content">
                                        <div className="ws-12 pts">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Description</th>
                                                        <th>IsActive</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        DescriptionList?.map(values => (
                                                            <tr>
                                                                <td>{values.description} </td>
                                                                <td>
                                                                    <a className={values.isActive ? "btn-xs icon-btn edit" : "btn-xs btn-grey"}>
                                                                        <i className="icon-checkmark3"></i>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>}
                                </div>
                            </div>

                        </div>

                        <div className="ws-9 landing">

                            {projectSettingUi &&
                                <div className="ws-6 shadowInset box" style={{ minHeight: "800px", position: "absolute" }}>
                                    <div style={{ height: "100%", top: 3, left: 5 }} className="dockingSlider">

                                        <i className="icon-close pull-right" style={{ position: "absolute", top: 15, right: 10 }} onClick={() => setprojectSettingUi(false)}></i>
                                        <ProjectSummarySetting project={projectDetails.projectDetails} />

                                    </div>
                                </div>}

                            <div className="ws-12 pLarge pts">

                                <div className="input-group">

                                    <AffiliatePeriod onChange={onChange} selectedPeriod={""} onChangeDate={onChangeDate}></AffiliatePeriod>
                                    <div className="pull-right pm mrl mtl text-bold"> {client && client.homeCurrency ? client.homeCurrency : ''}</div>

                                </div>

                                {<ProjectIndicators indicator={projectIndicators} project={projectDetails.projectDetails} type="horizontal" />/**/}

                                <div className="box">
                                    <table className="table ">
                                        <thead className="hide">
                                            <tr><th>Earned</th>
                                                <th>Gross Earnings</th>
                                                <th>Held</th>
                                                <th>Released</th>
                                            </tr></thead>
                                        <tbody>
                                            <tr>
                                                <td width="25%" className="warning  bg-level0 bg-white hide">Earned :  {projectIndicators.totalGrossEarnings}</td>
                                                <td width="25%" className="purple  bg-level0 bg-white">Gross Earnings :  {projectIndicators.totalGrossEarnings}</td>
                                                <td width="25%" className="danger  bg-level0 bg-white">Reserves Held :  {projectIndicators.totalReserveHeld}</td>
                                                <td width="25%" className="success  bg-level0 bg-white">Reserves Released :  {projectIndicators.totalReserveRelease}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="ws-12">
                                    <div className="mtl box pm">

                                        <div className="alert alert-warning mb hide">Calculations Initiated</div>

                                        <div className="ws-7">
                                            {openProjectAnalysis}-*-*
                                            {/*       <Performance projectDetails={projectDetails.projectDetails} />
                                            <Royalties projectDetails={projectDetails.projectDetails} /> */}

                                            <button className="text-center icon-btn info height35 width150" onClick={ProjectAnalysisopen}>
                                                Project Analysis
                                            </button>


                                            <ProjectValidation projectDetails={projectDetails.projectDetails} />
                                        </div>

                                        <ProjectCalculation projectDetails={projectDetails.projectDetails} />
                                        <ContractCompare projectDetails={projectDetails.projectDetails} />
                                        {/* <QueueRules projectDetails={projectDetails.projectDetails} /> */}

                                    </div>
                                </div>

                                <div className="box mt">
                                    <div className="box-header">Scope</div>
                                    <div className="box-content">
                                        <div className="ws-12">
                                            <ul className="nav nav-tabs ws-9">
                                                <li className={showtab === 1 ? "active mr" : "mr"} onClick={() => currentPage(1)}>Contracts</li>
                                                <li className={showtab === 2 ? "active mr" : "mr"} onClick={() => currentPage(2)}>Tracks</li>
                                                <li className={showtab === 3 ? "active mr" : "mr"} onClick={() => currentPage(3)}>Songs</li>
                                                <li className={showtab === 4 ? "active mr" : "mr"} onClick={() => currentPage(4)}>Release</li>
                                                <li className={showtab === 5 ? "active mr" : "mr"} onClick={() => currentPage(5)}>Users</li>

                                            </ul>
                                            {(showtab === 1) && <div className="pull-right">
                                                <input type="text" key='Search' className="slim" placeholder="Search Text"
                                                    value={searchValue}
                                                    onKeyDown={(e) => { if (e.code === "Enter") { searchBtn(searchValue); } }}
                                                    onChange={(e) => { setSearchValue(e.target.value) }} />
                                                <button className="icon-btn edit" >
                                                    <i className="icon-search" onClick={() => searchBtn(searchValue)}></i>
                                                </button>
                                            </div>}


                                        </div>
                                        <div className="ws-12">

                                            <div className="ws-12 pull-left pl ptl pb" >

                                                <h3 className="capitalize mb pull-left ws-5 ptl">  Associated track ({Associated})  </h3>

                                                <button className="icon-btn delete ms pull-left ml btn-sm hide">
                                                    <i className="icon-file-pdf-o"></i>
                                                </button>

                                                <div className={showtab === 1 ? "hide " : "hide"}>
                                                    <button onClick={() => { openMainWizard = true; setopenMainWizard(openMainWizard); console.log(openMainWizard) }}>Wizard</button>
                                                </div>

                                                <div className={showtab !== 1 ? "hide" : "hide"}>
                                                    <button className="icon-btn edit pull-right mb">Add New
                                                        {showtab === 4 ? " Release" : showtab === 3 ? " Songs" : showtab === 2 ? " Tracks" : showtab === 5 ? " Users" : ""}</button>
                                                </div>

                                                <div className={showtab === 3 ? "hide" : "hide"}>
                                                    <NewSongs />
                                                </div>

                                                <div className={showtab === 5 ? "hide" : "pull-right"}>
                                                    {/* <AssetLinking data={projectDetails.projectDetails} type={showtab} contractSearch={{ ProjectId: projectDetails?.projectDetails?.projectId }} /> */}
                                                    <button className="icon-btn primary pull-right mb" onClick={() => { openAssetLink = true; setopenAssetLink(openAssetLink); }}>Asset Linking</button>
                                                </div>


                                                <div className={showtab === 5 ? "" : "hide"}>
                                                    <AddUser data={projectDetails.projectDetails} />
                                                </div>
                                            </div>


                                            {(() => {
                                                switch (showtab) {
                                                    case 1: return <ContractListing contractSearch={{ ProjectId: projectDetails?.projectDetails?.projectId }} onChange={getRows} search={sndSearch} />;
                                                    case 4: return <ReleaseListing projectDetails={{ ProjectId: projectDetails?.projectDetails?.projectId }} onChange={getRows} />;
                                                    case 3: return <SongListing projectDetails={{ ProjectId: projectDetails?.projectDetails?.projectId }} onChange={getRows} />;
                                                    case 2: return <TrackListing projectDetails={{ ProjectId: projectDetails?.projectDetails?.projectId }} onChange={getRows} />;
                                                    case 5: return <UserListing projectDetails={{ ProjectId: projectDetails?.projectDetails?.projectId }} onChange={getRows} />;
                                                    default: return <ContractListing contractSearch={{ ProjectId: projectDetails?.projectDetails?.projectId }} onChange={getRows} />;
                                                }
                                            })()}



                                        </div>
                                    </div>
                                </div>


                                {(() => {
                                    if (openMainWizard) {
                                        return <MainWizard openMainWizard={openMainWizard} MainWizardClose={MainWizardClose} type="Contract" code="TPR320CW-TOTALModified" />
                                    }

                                    if (openAssetLink) {
                                        return <AssetLinking openAssetLink={openAssetLink} data={projectDetails.projectDetails} type={showtab} AssetLinkClose={AssetLinkClose} />
                                    }

                                    if (openProjectAnalysis && openProjectAnalysis == true) {
                                        return <ProjectAnalysis projectDetails={projectDetails.projectDetails} openProjectAnalysis={openProjectAnalysis} ProjectAnalysisClose={ProjectAnalysisopen}/>
                                    }


                                })()}

                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
        </div>
    );
}